import { useContext } from 'react';
import { ContentfulContext } from '../ContentfulProvider';
/** @public */
function useContentful(fieldName, defaultValue) {
    var contentful = useContext(ContentfulContext);
    if (!fieldName) {
        return contentful;
    }
    var pathArray = "fields.".concat(fieldName).split('.');
    return pathArray.reduce(function (prevPath, nextPath) { var _a; return (_a = prevPath === null || prevPath === void 0 ? void 0 : prevPath[nextPath]) !== null && _a !== void 0 ? _a : defaultValue; }, contentful);
}
export default useContentful;
//# sourceMappingURL=useContentful.js.map